<template>
  <Icon :component="ProfileSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import ProfileSvg from './svg/ProfileSvg.vue';

export default defineComponent({
  name: 'ProfileIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      ProfileSvg: markRaw(ProfileSvg)
    };
  }
});
</script>
